import { takeEvery, put, call } from "redux-saga/effects";
import apiCall from "../services"
import config from '../config/config.json';

function* ancillaryMaster(actions) {

    try {
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };

        const requestOptions = {
            headers: headers
        };

        let url = (actions.query === null) ? config.credentials.url + '/ancillary-master/' : config.credentials.url + '/ancillary-master/' + actions.query

        const response = yield call(apiCall, 'get', url, requestOptions)

        yield put({ type: "ANCILLARY_MASTER_RESPONSE", value: response })
    } catch (error) {
        yield put({ type: "ANCILLARY_MASTER_RESPONSE", value: error })
    }
}

function* ancillariesMaster(actions) {

    try {
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };

        const requestOptions = {
            headers: headers
        };

        let url = (actions.query === null)
            ? config.credentials.url + '/ancillary-master/list/?offset=0&limit=' + actions.limit
            : config.credentials.url + '/ancillary-master/list/' + actions.query;

        const response = yield call(apiCall, 'get', url, requestOptions)

        yield put({ type: "ANCILLARIES_MASTER_RESPONSE_LIST", value: response })
    } catch (error) {
        yield put({ type: "ANCILLARIES_MASTER_RESPONSE_LIST", value: error })
    }
}

function* remove(actions) {

    try {
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };

        const requestOptions = {
            headers: headers
        };

        const response = yield call(apiCall, 'delete', config.credentials.url + '/ancillary-master/' + actions.data + '/', requestOptions)
        yield put({ type: "ANCILLARY_MASTER_RESPONSE", value: response })
    } catch (error) {
        yield put({ type: "ANCILLARY_MASTER_RESPONSE", value: error })
    }
}

function* edit(actions) {
    try {
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };

        const requestOptions = {
            headers: headers,
            body: JSON.stringify(actions.data)
        };

        const response = yield call(apiCall, 'PATCH', config.credentials.url + '/ancillary-master/' + actions.id + '/', requestOptions)
        response.view = 'edit'
        yield put({ type: "ANCILLARY_MASTER_RESPONSE", value: response })
    } catch (error) {
        yield put({ type: "ANCILLARY_MASTER_RESPONSE_ERROR", value: error })
    }
}

function* add(actions) {

    try {

        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };
        const requestOptions = {
            headers: headers,
            body: JSON.stringify(actions.data)
        };

        const ancillaryMasterResponse = yield call(apiCall, 'post', config.credentials.url + '/ancillary-master/', requestOptions);
        ancillaryMasterResponse.view = 'create'
        yield put({ type: "ANCILLARY_MASTER_RESPONSE", value: ancillaryMasterResponse })
    } catch (error) {
        yield put({ type: "ANCILLARY_MASTER_RESPONSE_ERROR", value: error })
    }
}

// function* hashExportAncillaryMasters(actions) {
//     try {
//         const headers = {
//             'Content-Type': 'application/json',
//             Authorization: `Bearer ${actions.access}`,
//         };
//         const requestOptions = {
//             headers: headers,
//         };

//         let url =
//             actions.query === null
//                 ? config.credentials.url + '/ancillaryMaster/report_coupons/?offset=0&limit=1000000'
//                 : config.credentials.url +
//                 '/ancillaryMaster/report_coupons/' +
//                 actions.query +
//                 '&offset=0&limit=100000';
//         const response = yield call(apiCall, 'get', url, requestOptions);

//         yield put({ type: 'HASH_EXPORT_ANCILLARIES_MASTER_RESPONSE', value: response });
//     } catch (error) {
//         yield put({ type: 'HASH_EXPORT_ANCILLARIES_MASTER_RESPONSE', value: error });
//     }
// }

// function* checkExportAncillaryMasters(actions) {
//     try {
//         const headers = {
//             'Content-Type': 'application/json',
//             Authorization: `Bearer ${actions.access}`,
//         };
//         const requestOptions = {
//             headers: headers,
//         };

//         const response = yield call(
//             apiCall,
//             'GET',
//             config.credentials.url + '/report/' + actions.hash + '/',
//             requestOptions
//         );

//         yield put({ type: 'REPORT_EXPORT_ANCILLARIES_MASTER_RESPONSE', value: response });
//     } catch (error) {
//         yield put({ type: 'REPORT_EXPORT_ANCILLARIES_MASTER_RESPONSE', value: error });
//     }
// }

export function* getAncillaryMaster() {
    yield takeEvery("GET_ANCILLARY_MASTER", ancillaryMaster)
}

export function* getAncillariesMasterList() {
    yield takeEvery("GET_ANCILLARIES_MASTER", ancillariesMaster)
}

export function* addAncillaryMaster() {
    yield takeEvery("ADD_ANCILLARY_MASTER", add)
}

export function* editAncillaryMaster() {
    yield takeEvery("EDIT_ANCILLARY_MASTER", edit)
}

export function* removeAncillaryMaster() {
    yield takeEvery("REMOVE_ANCILLARY_MASTER", remove)
}

// export function* getHashExportAncillaryMastersList() {
//     yield takeEvery('GET_HASH_EXPORT_ANCILLARIES_MASTER', hashExportAncillaryMasters);
// }

// export function* checkExportAncillaryMastersList() {
//     yield takeEvery('CHECK_EXPORT_ANCILLARIES_MASTER', checkExportAncillaryMasters);
// }
